import { render, staticRenderFns } from "./AccomodationDisplay.vue?vue&type=template&id=41c381b6&"
import script from "./AccomodationDisplay.vue?vue&type=script&lang=js&"
export * from "./AccomodationDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports